import PageHeader from "@/components/layout/PageHeader";
import AboutOverview from "@/components/home/AboutOverview";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import { BUSINESS } from "@/lib/constants";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function About() {
  return (
    <>
      <PageHeader
        eyebrow="About Us"
        title="A friendly FASTag counter at Bally Toll Plaza."
        subtitle="Helping motorists, taxi operators and fleet managers complete essential FASTag tasks quickly and confidently."
        primary={{ to: "/order", label: "Order FASTag" }}
        secondary={{ to: "/contact", label: "Contact Us" }}
      />
      <AboutOverview />
      <WhyChooseUs />

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 gap-6">
            {[
              { icon: MapPin, label: "Address", value: BUSINESS.address },
              { icon: Phone, label: "Phone", value: BUSINESS.phoneDisplay },
              { icon: Mail, label: "Email", value: BUSINESS.email },
              { icon: Clock, label: "Hours", value: BUSINESS.hours.map(h => `${h.day}: ${h.time}`).join(" • ") },
            ].map((it, i) => (
              <div key={i} className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-2xl p-5 flex gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#0057B8]/10 text-[#0057B8] grid place-items-center shrink-0"><it.icon className="w-5 h-5" /></div>
                <div>
                  <div className="text-xs font-semibold uppercase tracking-widest text-[#0E7490]">{it.label}</div>
                  <div className="mt-1 text-[#111827]">{it.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
